export const listaStatus = [
    {name: 'Ativo', label: 'Ativo', value: true}, 
    {name: 'Inativo', label: 'Inativo', value: false},
];


export const CONTACTS = {
    EMAIL: 'suporte@apphealth.com.br',
    WHATSAPP_NUMBER: '5544991152683',
}